import React from 'react';
import { conditionCodeToName } from '../../../../../common/src/condition/conditionCodeToName';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { InspectionStandardTypes } from '../../../utils/enums/InspectionStandardTypes';
import { isEemuaOrApi } from '../../../utils/isEemuaOrApi';
import { EditPanelCell, EditPanelRow, EditPanelSection, EditPanelSelect, EditPanelSwitch, EditPanelTextArea } from '../../elements';
import { ConditionScoreLabel } from '../../utils/ConditionScoreLabel';

interface IConditionEditProps extends ITranslateProps {
    score?: undefined | string | null;
    careScore?: undefined | string;
    conditionAdvice: string;
    isFurtherInvestigation?: undefined | boolean;
    investigationPriority?: undefined | string | null;
    objectInspectionStandardType: InspectionStandardTypes;
    canSetConditionScoreWhenDefects: boolean;
    canSetInvestigationPriority: boolean;
    conditionOptions: { value: string; translateText: string }[];
    handleChange: (e: any, target: string) => void;
    removeConditionClicked: (e: any) => void;
    saveConditionClicked: (e: any) => void;
}

class ConditionEdit extends React.Component<IConditionEditProps, Record<string, unknown>> {
    constructor(props: IConditionEditProps) {
        super(props);
        this.state = {};
    }

    public override render() {
        return (
            <div>
                <form method="post" action="/" id="admin-form" onSubmit={(e) => this.props.saveConditionClicked(e)}>
                    {((this.props.canSetConditionScoreWhenDefects || this.props.score === 'U' || this.props.score === '0') && (
                        <div className="section mt30">
                            <label className="score field select">
                                <select
                                    id="condition-select"
                                    name="condition "
                                    className={`label-${conditionCodeToName(this.props.score)}`}
                                    value={this.props.score ?? ''}
                                    onChange={(e) => this.props.handleChange(e.target.value, 'score')}
                                >
                                    <option value="">{this.props.t('common.selectItem', this.props.t('common.condition'))}</option>

                                    {this.props.conditionOptions.map((option, i) => (
                                        <option key={i} value={option.value}>
                                            {this.props.t(option.translateText)}
                                        </option>
                                    ))}
                                </select>
                                <i className="arrow" />
                            </label>
                        </div>
                    )) || (
                        <>
                            <div className="mb20 mt20 ml10">
                                {this.props.t('survey.compositeCondition')}: <ConditionScoreLabel value={this.props.score} />
                                {this.props.careScore && (
                                    <span className="ml30">
                                        {this.props.t('survey.compositeCare')}: <ConditionScoreLabel value={this.props.careScore} />{' '}
                                    </span>
                                )}
                            </div>
                        </>
                    )}

                    {/* Further investigation */}
                    {this.props.canSetInvestigationPriority && this.props.score && (
                        <EditPanelRow>
                            <div className="mt10">
                                {this.props.score !== 'F' && (
                                    <EditPanelCell rowCount={5}>
                                        <EditPanelSwitch
                                            name="isFurtherInvestigation"
                                            placeholder={this.props.t('survey.furtherInvestigation')}
                                            value={this.props.isFurtherInvestigation}
                                            handleChange={this.props.handleChange.bind(this)}
                                        />
                                    </EditPanelCell>
                                )}
                                {(this.props.score === 'F' || this.props.isFurtherInvestigation) && (
                                    <div className="pt10">
                                        <label htmlFor="investigationPriority" className="field-label col-md-2 nowrap">
                                            {this.props.t('survey.priorityFurtherInvestigation')}:{' '}
                                        </label>
                                        <EditPanelCell rowCount={3}>
                                            <EditPanelSelect
                                                name="investigationPriority"
                                                value={this.props.investigationPriority}
                                                handleChange={this.props.handleChange.bind(this)}
                                                options={[
                                                    { value: '0', text: this.props.t('common.selectItem', this.props.t('common.priority')) },
                                                    { value: '1', text: this.props.t('investigationPriority.1') },
                                                    { value: '2', text: this.props.t('investigationPriority.2') },
                                                    { value: '3', text: this.props.t('investigationPriority.3') },
                                                ]}
                                            />
                                        </EditPanelCell>
                                    </div>
                                )}
                            </div>
                        </EditPanelRow>
                    )}

                    {/* Description */}
                    <EditPanelSection>
                        <EditPanelTextArea
                            name="conditionAdvice"
                            placeholder={this.props.t('common.description')}
                            value={this.props.conditionAdvice}
                            icon="fa fa-info"
                            handleChange={this.props.handleChange.bind(this)}
                        />
                    </EditPanelSection>

                    {/* Buttons */}
                    <div className="br-b p12 text-right ">
                        <a href="# " onClick={(e) => this.props.removeConditionClicked(e)} className="btn btn-default btn-sm fw600 mr10 ">
                            <span className="fa fa-trash-o pr5 " />{' '}
                            {this.props.t(
                                'common.removeItem',
                                isEemuaOrApi(this.props.objectInspectionStandardType)
                                    ? this.props.t('survey.conditionRepairs')
                                    : this.props.t('survey.conditionDefects'),
                            )}
                        </a>
                        <a href="# " onClick={(e) => this.props.saveConditionClicked(e)} className="btn btn-primary btn-sm fw600 ">
                            <span className="fa fa-save pr5 " /> {this.props.t('common.saveItem', this.props.t('common.condition'))}
                        </a>
                    </div>
                </form>
            </div>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(ConditionEdit);
